import React from "react";
import { SwiperSlide } from "swiper/react";
import { SwiperWraperAffiliate } from "./styles";
import { CardOption } from "./CardOption";
import { useApp } from "../../contexts";
import { useWindowSize } from "../../hook/useWindowSize";
import { formatMoney } from "../../utils/hepler";

const formatCVR = (cvr) => {
  if (cvr > 100) {
    return `${cvr.toFixed(0)}%`;
  } else {
    return `${cvr.toFixed(2)}%`;
  }
}

export const SlideOption = ({ data }) => {
  const { T } = useApp();
  const size = useWindowSize();
  const getSlidePreview = () => {
    let preview = 3;
    if (size.width < 576) {
      preview = 2.92;
    }
    return preview;
  };
  return (
    <div className="w-[100%]">
      {/* <SwiperWraperAffiliate
        slidesPerView={getSlidePreview()}
        spaceBetween={20}
      >
        <SwiperSlide>
          <CardOption
            value={data?.summary?.total_click ?? 0}
            title={T("Clicks")}
          />
        </SwiperSlide>
        <SwiperSlide>
          <CardOption value={data?.summary?.cv ?? 0} title={T("Conversion")} />
        </SwiperSlide>
        <SwiperSlide>
          <CardOption value={`${(data?.summary?.cvr ?? 0)?.toFixed(2)}%`} title={T("CVR")} />
        </SwiperSlide>
      </SwiperWraperAffiliate> */}
      <div className="flex justify-between items-center md:px-[60px] lg:px-[0]">
        <CardOption
          value={data?.summary?.total_click ?? 0}
          title={T("Clicks")}
        />
        <CardOption value={data?.summary?.cv ?? 0} title={T("Conversion")} />
        <CardOption
          value={`${formatCVR((data?.summary?.cvr ?? 0))}`}
          title={T("CVR")}
        />
      </div>
    </div>
  );
};
